<!--成功客户-->
<template>
    <div class='all-body'>
        <div class='child-body'>
            <div class='scenarioTitle'>{{name}}</div>
            <div class='successCustomers'>
                <img  v-for="item of data" :src='item' alt=""> 
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'index',
    props: ['data', 'name' ]
}
</script>
<style scoped>
.successCustomers{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.successCustomers img{
    width: 188px;
    height: 75px;
    background: #FFFFFF;
    border: 1px solid #E4E4E4;
    box-shadow: 0px 3px 14px 0px rgba(93, 121, 164, 0.16);
    margin: 0px 12px 12px 0px;
}
.successCustomers img:nth-child(6n+6){
    margin-right: 0 !important;
}


</style>